import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { AuthenticationService } from 'app/auth/service';
import { User } from 'app/auth/models';
import { MenuService } from '@core/services/menu.service';

@Injectable({
  providedIn: 'root'
})
export class CoreMenuService {
  currentUser: User;
  onItemCollapsed: Subject<any>;
  onItemCollapseToggled: Subject<any>;

  // Private
  private _onMenuRegistered: BehaviorSubject<any>;
  private _onMenuUnregistered: BehaviorSubject<any>;
  private _onMenuChanged: BehaviorSubject<any>;
  private _currentMenuKey: string;
  private _registry: { [key: string]: any } = {};

  constructor(private _router: Router, private _authenticationService: AuthenticationService, private _menuService: MenuService) {
    this._authenticationService.currentUser.subscribe(x => (this.currentUser = x));

    // Set defaults
    this.onItemCollapsed = new Subject();
    this.onItemCollapseToggled = new Subject();

    // Set private defaults
    this._currentMenuKey = null;
    this._onMenuRegistered = new BehaviorSubject(null);
    this._onMenuUnregistered = new BehaviorSubject(null);
    this._onMenuChanged = new BehaviorSubject(null);

    // Carregar os menus quando o serviço for iniciado
    // console.log('🚀 CoreMenuService inicializado.');
    // this.loadMenus();

  }

  // private  loadMenus(): Promise<void> {
  //  this._menuService.get().subscribe(response => {
  //   console.log('✅ Menus carregados da API:', response);

  //   const menus = response.data;
  //   if (!menus || menus.length === 0) {
  //     console.warn('⚠️ Nenhum menu foi retornado da API.');
  //     return;
  //   }

  //     menus.forEach(menu => {
  //       if (!menu.id_menu) {
  //         console.error('❌ Erro: id_menu ausente no menu:', menu);
  //         return;
  //       }
  //       this.register(menu.id_menu, menu);
  //     });

  //     console.log('📌 Registro final de menus:', this._registry);
  //   });
  // }


  // Accessors
  get onMenuRegistered(): Observable<any> {
    return this._onMenuRegistered.asObservable();
  }

  get onMenuUnregistered(): Observable<any> {
    return this._onMenuUnregistered.asObservable();
  }

  get onMenuChanged(): Observable<any> {
    return this._onMenuChanged.asObservable();
  }

  // Public methods

  // Busca os menus da API e registra/atualiza o menu "main".
  // Chamado no bootstrap (app.component) e logo apos o login gravar o tokenApiG2E —
  // sem a segunda chamada o menu so aparecia depois de um refresh manual.
  carregarMenus(): void {
    if (!localStorage.getItem('tokenApiG2E')) {
      // Sem token (ex.: tela de login) a chamada so geraria um 401 no console.
      return;
    }

    this._menuService.get().subscribe((res) => {
      if (res && res.data) {
        const menu = res.data.map((item) => {
          const transformedItem: any = {
            id: item.id_menu,
            title: item.title,
            type: item.tipo,
            icon: item.icon,
          };

          if (item.tipo === 'item') {
            transformedItem.url = item.url;
          } else if (item.tipo === 'collapsible' && Array.isArray(item.children)) {
            transformedItem.children = item.children.map((subItem) => ({
              id: subItem.id_menu,
              title: subItem.title,
              type: subItem.tipo,
              url: subItem.url,
            }));
          }

          return transformedItem;
        });

        if (this._registry['main']) {
          this.unregister('main');
        }
        this.register('main', menu);
        this.setCurrentMenu('main');
      }
    });
  }

  register(key, menu): void {
    // console.log('🔹 Tentando registrar menu:', key, menu);
    if (this._registry[key]) {
      console.error(`⚠️ Erro: Menu com a chave '${key}' já existe.`);
      return;
    }

    // Adicionar ao registro
    this._registry[key] = menu;
    // console.log(`✅ Menu '${key}' registrado com sucesso!`);
    // Notificar evento
    this._onMenuRegistered.next([key, menu]);
  }

  unregister(key): Promise<void> {
    if (!this._registry[key]) {
      console.warn(`⚠️ Aviso: Menu com a chave '${key}' não existe no registro.`);
      return;
    }

    delete this._registry[key];
    // console.log(`✅ Menu '${key}' removido do registro.`);
    this._onMenuUnregistered.next(key);
  }

  getMenu(key): any {
  // console.log(`✅ GetMenu '${key}' do registro.`);
  if (!this._registry[key]) {
    console.warn(`⚠️ Aviso: Menu com a chave '${key}' não existe no registro.`);
    return null; // Retornar `null` em vez de `undefined` pode evitar erros no *ngFor
  }
  return this._registry[key]; // Retorna os dados corretamente
}

  getCurrentMenu(): Promise<void> {
    if (!this._currentMenuKey) {
      console.warn(`⚠️ Aviso: Nenhum menu atual foi definido.`);
      return;
    }
    // console.log('📌 Obtendo menu atual:', this._currentMenuKey);
    return this.getMenu(this._currentMenuKey);
  }

  setCurrentMenu(key): Promise<void> {
    // console.log('🔄 Tentando definir menu atual:', key);
    if (!this._registry[key]) {
      console.warn(`⚠️ Erro: Menu com a chave '${key}' não está registrado.`);
      return;
    }

    this._currentMenuKey = key;
    // console.log(`✅ Menu atual definido para '${key}'.`);
    // Notificar evento
    this._onMenuChanged.next(key);
  }
}
